import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableComponent } from '../../../core/table/table.component';
import { ColumnComponent } from '../../../core/table/column.component';
import {
  LoadingPanelComponent,
  LoadingState,
} from '../../../core/panels/loading-panel.component';
import { BaseComponent } from '../../../base/base.component';

@Component({
  selector: 'app-reserves-attributes-tab',
  imports: [
    CommonModule,
    TableComponent,
    ColumnComponent,
    LoadingPanelComponent,
  ],
  template: `
    <app-loading-panel
      [state]="loadingState"
      loadingStyle="Skeleton"
      [loadingHeight]="215"
    >
      <ng-template #loaded>
        @if (!workersComp) {
          <div class="tw-flex tw-basis-full tw-gap-8">
            <div class="tw-basis-full">
              <app-table
                [dataSource]="attributes"
                [pageSize]="5"
                [scrollable]="false"
                dataKey="attributeType"
                recordLabel="Attribute"
                [theme]="'Dark'"
              >
                <app-column name="attributeType" label="Name" />
                <app-column name="attributeTypeDesc" label="Name description" />
                <app-column name="attributeValue" label="value" />
                <app-column
                  name="attributeValueDesc"
                  label="value description"
                />
                <app-column name="attributeCategory" label="category" />
                <app-column name="attributeSubCategory" label="Sub category" />
                <app-column name="fieldType" label="Field type" />
                <app-column name="deleted" label="Deleted" format="b" />
              </app-table>
            </div>
          </div>
        } @else {
          <div class="tw-basis-full">
            <app-table
              [dataSource]="attributes"
              [pageSize]="5"
              [scrollable]="false"
              dataKey="attributeType"
              sortField="attributeType"
              [sortOrder]="1"
              recordLabel="Attribute"
              [theme]="'Dark'"
            >
              <app-column name="attributeType" label="type" />
              <app-column name="attributeValue" label="value" />
              <app-column name="attributeCategory" label="category" />
              <app-column name="attributeSubCategory" label="Sub category" />
              <app-column name="deleted" label="Deleted" format="b" />
            </app-table>
          </div>
        }
      </ng-template>
    </app-loading-panel>
  `,
  styles: ``,
})
export class ReservesAttributesTabComponent extends BaseComponent {
  @Input()
  workersComp = false;

  @Input()
  attributes: any[] = [];

  loadingState: LoadingState = 'Loaded';
}
